import { getRouteTel, hashQueryKeyWithoutTel } from '@w/tel'
import { diff, isTest, safe } from '@w/utils'

export function createReactQuerySpanEvent(event: {
  type: string
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  query: { queryKey: string[]; state: { error: any; data: any } }
  action?: { type: string }
}) {
  if (event.type !== 'updated' || isTest) return
  if (!Array.isArray(event.query.queryKey)) {
    console.error('query key is not an array', event.query.queryKey)
    return
  }

  const key = event.query.queryKey
  const hashedKey = hashQueryKeyWithoutTel(key)

  getRouteTel().createEvent(hashedKey, (old) => {
    const newData = event.query.state.error ? event.query.state.error : event.query.state.data
    const data = diff(old?.data as a, newData)
    return {
      name: safe(event.action).type, // safe for update events // "setState" | "fetch", etc
      target: 'react-query',
      data,
    }
  })
}

// function jsonStringifySorted(obj: a, _replacer = null, space = 2) {
//   return JSON.stringify(
//     obj,
//     (_, value) => {
//       // Check if the value is an object (but not an array)
//       if (value && typeof value === 'object' && !Array.isArray(value)) {
//         const sortedKeys = Object.keys(value).sort()
//         const sortedObj: a = {}
//         for (const k of sortedKeys) {
//           sortedObj[k] = value[k]
//         }
//         return sortedObj
//       }
//       return value
//     },
//     space,
//   )
// }

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
type a = any
